/**
 * Client-side Slack webhook sender. Authenticates via Supabase session
 * and sends through the /api/sendSlackWebhook proxy.
 */

import { supabaseClient } from '~/shared/common/supabase/client'
import type { SlackChannel, SlackMessageRequest } from '~/shared/common/slack'

export type { SlackChannel, SlackMessageRequest }

export async function sendSlackWebhookClient(params: SlackMessageRequest): Promise<{ success: boolean; error?: string }> {
  const {
    data: { session },
  } = await supabaseClient.auth.getSession()
  const token = session?.access_token
  if (!token) throw new Error('Not authenticated')

  const response = await fetch('/api/sendSlackWebhook', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(params),
  })

  if (!response.ok) {
    const errBody = (await response.json().catch(() => ({ error: 'Unknown error' }))) as { error?: string }
    throw new Error(errBody.error || `HTTP ${response.status}`)
  }

  return response.json()
}
